import React from 'react';
import { ArrowDownRight, ArrowRight, Info } from 'lucide-react';
import { FunnelStageData } from '../utils/mockData';
interface StageMetricCardProps {
  stage: FunnelStageData;
  isLast?: boolean;
}
export function StageMetricCard({
  stage,
  isLast
}: StageMetricCardProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 flex flex-col h-full relative overflow-hidden" data-id="element-98">
      {/* Top accent bar matching stage color */}
      <div className="absolute top-0 left-0 right-0 h-1" style={{
      backgroundColor: stage.color
    }} data-id="element-99" />

      <div className="flex justify-between items-start mb-4" data-id="element-100">
        <div data-id="element-101">
          <h3 className="text-sm font-medium text-slate-500 uppercase tracking-wide" data-id="element-102">
            {stage.name}
          </h3>
          <p className="text-xs text-slate-400 mt-1 line-clamp-2" title={stage.description} data-id="element-103">
            {stage.description}
          </p>
        </div>
        <div className="p-2 bg-slate-50 rounded-full text-slate-400" data-id="element-104">
          <Info size={16} data-id="element-105" />
        </div>
      </div>

      <div className="mt-auto" data-id="element-106">
        <div className="flex items-baseline gap-2" data-id="element-107">
          <span className="text-3xl font-bold text-slate-900" data-id="element-108">
            {stage.value.toLocaleString()}
          </span>
          <span className="text-sm text-slate-500 font-medium" data-id="element-109">Volume</span>
        </div>

        {!isLast && <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-2 gap-4" data-id="element-110">
            <div data-id="element-111">
              <div className="flex items-center gap-1 text-emerald-600 text-sm font-semibold" data-id="element-112">
                <ArrowRight size={14} data-id="element-113" />
                {stage.conversionRate}
              </div>
              <p className="text-xs text-slate-500 mt-0.5" data-id="element-114">Conversion</p>
            </div>
            <div data-id="element-115">
              <div className="flex items-center gap-1 text-rose-500 text-sm font-semibold" data-id="element-116">
                <ArrowDownRight size={14} data-id="element-117" />
                {stage.dropOffRate}
              </div>
              <p className="text-xs text-slate-500 mt-0.5" data-id="element-118">Drop-off</p>
            </div>
          </div>}

        {isLast && <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-119">
            <div className="flex items-center gap-1 text-emerald-600 text-sm font-semibold" data-id="element-120">
              Revenue Generated
            </div>
            <p className="text-xs text-slate-500 mt-0.5" data-id="element-121">
              Primary Success Metric
            </p>
          </div>}
      </div>
    </div>;
}